import { createAction, props } from '@ngrx/store';
import { SearchGroupsInput } from '../../../shared/data/inputs/search-groups.input';
import { GroupConnectionsModel } from '../../../shared/data/models/group-connections.model';
import { GroupModel } from '../../../shared/data/models/group.model';
import { GroupMemberModel } from '../../../shared/data/models/group-member.model';
import { DeleteResultModel } from '../../../shared/data/models/delete-result.model';

export const groupAction = createAction(
  '[GroupList] Load groups list',
  props<{ input: SearchGroupsInput }>()
);

export const groupListLoadMoreAction = createAction(
  '[GroupList] Load More groups list',
  props<{ input: SearchGroupsInput }>()
);

export const groupListSuccessAction = createAction(
  '[GroupList] Load groups list Success',
  props<{ payload: GroupConnectionsModel }>()
);

export const groupListLoadMoreSuccessAction = createAction(
  '[GroupList] Load More Success groups list',
  props<{ payload: GroupConnectionsModel }>()
);

export const groupListErrorAction = createAction(
  '[GroupList] Load groups list Error',
  props<{ error: string }>()
);

/**
 * get data of a single group post
 **/
export const getGroupDetail = createAction(
  '[GROUP] get group detail',
  props<{ groupID: string }>()
);

export const getGroupDetailSuccess = createAction(
  '[GROUP] get group detail success',
  props<{ payload: GroupModel }>()
);

export const currentGroupError = createAction(
  '[GROUP] set current group error',
  props<{ error: string }>()
);

/*
 * join current group
 * */

export const joinCurrentGroup = createAction(
  '[GROUP] join current group',
  props<{ groupID: string }>()
);

export const joinCurrentGroupSuccess = createAction(
  '[GROUP] join current group Success',
  props<{ payload: GroupMemberModel }>()
);

/*
 * Leave group feature.
 **/
export const leaveCurrentGroup = createAction(
  '[GROUP] leave current group',
  props<{ groupID: string }>()
);

export const leaveCurrentGroupSuccess = createAction(
  '[GROUP] leave current group success',
  props<{ payload: DeleteResultModel }>()
);
